export default __webpack_public_path__ + "static/media/autumnFlower.32e5bb6d.jpg";